export default __webpack_public_path__ + "static/media/swing_5_high.07ef5c3e.svg";